class ShowcaseCarousel extends window.BAO.Carousel.Element {
  initialiseCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        slides: {
          perView: 2.5,
          spacing: 20,
        },
        breakpoints: {
          [`(min-width: 1000px)`]: {
            disabled: this.els.slide.elements.length <= 5,
            slides: {
              perView: 5.4,
              spacing: 40,
            },
          },
        },
        loop: false,
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useDots(this.els?.dot?.elements ?? []),
        window.BAO.Carousel.useArrows({
          next: this.externalEls.next.element,
          previous: this.externalEls.previous.element,
        }),
      ],
    )
  }
}

if (!customElements.get('showcase-carousel')) {
  customElements.define('showcase-carousel', ShowcaseCarousel)
}
